import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

// Vertical progress for this window. Steps are { key, label, done, onClick }; the first
// unfinished one is current.
export default function StepRail({ steps }) {
  const currentIdx = steps.findIndex((s) => !s.done);
  return (
    <nav aria-label="Design progress" data-testid="window-step-rail">
      <ol className="relative">
        {steps.map((s, idx) => {
          const current = idx === currentIdx;
          const isLast = idx === steps.length - 1;
          return (
            <li key={s.key} className="relative pb-7 last:pb-0">
              {!isLast && (
                <span aria-hidden="true" className={cn("absolute left-[13px] top-8 bottom-1 w-px", s.done ? "bg-primary" : "bg-border")} />
              )}
              <button
                type="button"
                onClick={s.onClick}
                aria-current={current ? "step" : undefined}
                data-testid={`window-step-${s.key}`}
                className="group flex items-center gap-3 text-left"
              >
                <span
                  className={cn(
                    "h-7 w-7 rounded-full flex items-center justify-center text-xs font-semibold shrink-0 transition-colors",
                    s.done && "bg-primary text-primary-foreground",
                    current && "bg-accent text-accent-foreground ring-4 ring-accent/15",
                    !s.done && !current && "bg-card border border-border text-muted-foreground",
                  )}
                >
                  {s.done ? <Check className="h-3.5 w-3.5" strokeWidth={2.5} /> : idx + 1}
                </span>
                <span
                  className={cn(
                    "text-sm group-hover:text-foreground transition-colors",
                    current ? "text-foreground font-medium" : s.done ? "text-foreground/85" : "text-muted-foreground",
                  )}
                >
                  {s.label}
                </span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
